import React from 'react';
import { FormProvider } from './src/components/ValuationForm/FormContext';

export function wrapRootElement({ element, pageContext }) {
    return <FormProvider pageContext={pageContext}>{element}</FormProvider>
}